import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import BookingEmbed from "@/components/BookingEmbed";
import { IMAGES } from "@/data/content";

export default function BookNow() {
  return (
    <div data-testid="book-page">
      <Seo
        title="Book Now"
        path="/book"
        description="Book your appointment at Barrhaven Beauty Lounge in Nepean, Ottawa. Choose your treatment and time online, or reach out and our team will help you plan the perfect visit."
      />
      <PageHero
        script="book now"
        title="Reserve your moment."
        subtitle="Choose your treatment and time online, or reach out and our team will help you plan the perfect visit."
      />

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="relative h-full min-h-[360px] overflow-hidden rounded-2xl">
                <img
                  src={IMAGES.interior}
                  alt="Barrhaven Beauty Lounge"
                  className="h-full w-full object-cover"
                />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <BookingEmbed />
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
